import { z } from "zod"
import { InvoiceStatus, SortDirection } from "@mimber/schema"

export const exportDuesInvoicesCsvFormSchema = z
  .object({
    search: z.string().trim().optional(),
    status: z.nativeEnum(InvoiceStatus).optional(),
    sortField: z
      .enum(["invoiceNumber", "status", "issuedAt", "dueAt", "totalAmount"])
      .optional(),
    sortDirection: z.nativeEnum(SortDirection).optional(),
  })
  .refine(
    (data) =>
      (!data.sortField && !data.sortDirection) ||
      (!!data.sortField && !!data.sortDirection),
    {
      message: "Sort field and direction must be selected together",
      path: ["sortDirection"],
    }
  )

export type ExportDuesInvoicesCsvFormData = z.infer<
  typeof exportDuesInvoicesCsvFormSchema
>
